const GRADIENTS = [
  "from-violet-500 to-fuchsia-500",
  "from-abyss-400 to-abyss-600",
  "from-shallow-400 to-shallow-600",
  "from-signal-400 to-signal-600",
  "from-violet-400 to-purple-600",
  "from-emerald-400 to-teal-600",
  "from-pink-400 to-rose-600",
  "from-cyan-400 to-blue-600",
] as const;

/** Returns a deterministic Tailwind gradient class pair for any string ID. */
export function gradientForId(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
  }
  return GRADIENTS[Math.abs(hash) % GRADIENTS.length]!;
}
